import React from 'react';
import { Divider } from '@mui/material';

import { Action, ContentTypes } from 'helpers';
import PopupAction from 'components/Misc/PopupActions/components/PopupAction';

function ContentPopup({ object, level, onClose, readOnlyMode }) {
    return (
        <React.Fragment>
            <PopupAction
                action={Action.Edit}
                object={object}
                level={level}
                showLabel={true}
                onActionHandled={onClose}
            />
            {object?.url && (
                <>
                    <Divider />
                    <PopupAction
                        action={Action.CopyContentUrl}
                        object={object}
                        level={level}
                        showLabel={true}
                        onActionHandled={onClose}
                    />
                </>
            )}
            {object?.content_version_type == 2 && object?.caption_languages?.length > 0 && (
                <>
                    <Divider />
                    <PopupAction
                        action={Action.EditCaptions}
                        object={object}
                        level={level}
                        showLabel={true}
                        onActionHandled={onClose}
                    />
                </>
            )}
            {readOnlyMode === false && (
                <>
                    {object?.content_type_id !== ContentTypes.Sme.id && (
                        <>
                            <Divider />
                            <PopupAction
                                action={Action.CreateContentVersion}
                                object={object}
                                level={level}
                                showLabel={true}
                                onActionHandled={onClose}
                            />
                        </>
                    )}
                    <Divider />
                    <PopupAction
                        action={Action.Delete}
                        object={object}
                        level={level}
                        showLabel={true}
                        onActionHandled={onClose}
                    />
                </>
            )}
        </React.Fragment>
    );
}

export { ContentPopup };
